import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { tap } from 'rxjs/operators';
import { AuthenticationActions } from '../../../auth/state/authentication.actions';
import { User } from '../../model/user.model';
import { AccountService } from '../../services/account.service';
import { RouteActions } from './route.actions';
import { PathAndParam } from './route.state';

@Injectable()
export class RouteEffect {

  constructor(private actions$: Actions,
              private accountService: AccountService,
              private store: Store<any>) {
  }

  loginUserSuccess: Observable<Action> = createEffect(() =>
      this.actions$.pipe(
        ofType(AuthenticationActions.loginUserSuccess),
        tap((action: any) => {

          const defaultPathAndParam: PathAndParam = {path: '/patients', param: 'patientid'};
          const alternativePathAndParam: PathAndParam =  {path: '/clients', param: 'clientid'};
          const VET_PERMISSION_KEY = 'resource:pets';
          const ROUTE_NAME = 'USER';

          const user = action.user as User;

          if (this.accountService.hasUserPermissionKey(user, VET_PERMISSION_KEY)) {
            this.store.dispatch(RouteActions.setRouteAndPath({route: ROUTE_NAME, pathAndParam: alternativePathAndParam}));

            return;
          }

          this.store.dispatch(RouteActions.setRouteAndPath({route: ROUTE_NAME, pathAndParam: defaultPathAndParam}));

        })
      ),
    {dispatch: false}
  );
}
